var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    padding: calc(", " / 2) 0;\n    \n    &:first-child {\n        padding-top: ", ";\n    }\n    &:last-child {\n        padding-bottom: 0;\n    }\n    \n    ", "\n"], ["\n    position: relative;\n    padding: calc(", " / 2) 0;\n    \n    &:first-child {\n        padding-top: ", ";\n    }\n    &:last-child {\n        padding-bottom: 0;\n    }\n    \n    ",
    "\n"])), function (props) { return props.theme.builder.spacing; }, function (props) { return props.theme.builder.spacing; }, function (props) {
    if (props.withLink === false)
        return '';
    return "\n            &:before {\n                content: \"\";\n                position: absolute;\n                width: 2px;\n                top: 0;\n                left: 22px;\n                bottom: 0;\n                background: " + props.theme.builder.link.color + ";\n            }\n        ";
});
var Header = styled_components_1.default.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n"], ["\n"])));
var Title = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 600;\n"], ["\n    font-weight: 600;\n"])));
var Content = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 9px 16px;\n    border-radius: 2px;\n    position: relative;\n    background: ", ";\n    ", "\n    \n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 4px;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        background: ", ";\n    }\n"], ["\n    padding: 9px 16px;\n    border-radius: 2px;\n    position: relative;\n    background: ", ";\n    ", "\n    \n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 4px;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        background: ", ";\n    }\n"])), function (props) { return props.theme.builder.block.background; }, function (props) { return props.theme.builder.block.css; }, function (props) { return props.markerColor; });
var Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Block.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, withLink = _a.withLink, withMarker = _a.withMarker, markerColorKey = _a.markerColor, theme = _a.theme;
        if (title === undefined && children === undefined) {
            return null;
        }
        var markerColor = theme.colors[markerColorKey];
        if (markerColor === undefined) {
            markerColor = markerColorKey;
        }
        return (React.createElement(Container, { withLink: withLink },
            React.createElement(Content, { withMarker: withMarker, markerColor: markerColor },
                title && (React.createElement(Header, null,
                    React.createElement(Title, null, title))),
                React.createElement("div", null, children))));
    };
    Block.defaultProps = {
        withMarker: true,
        markerColor: 'accent',
        withLink: false
    };
    return Block;
}(React.Component));
exports.default = styled_components_1.withTheme(Block);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
